import React, { useState, useEffect } from "react";
import { db } from "../config/firestore";
import { collection, getDocs } from "firebase/firestore";
import Leaderboard from "./Leaderboard";

const DayLeaderboard = ({ challenge, user, onStart, onBack, userProgress }) => {
  const [dayLeaderboard, setDayLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alreadyCompleted, setAlreadyCompleted] = useState(false);
  const [userScore, setUserScore] = useState(null);

  useEffect(() => {
    fetchDayLeaderboard();
    checkIfCompleted();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [challenge.day]);

  const checkIfCompleted = () => {
    if (userProgress && userProgress[`day${challenge.day}`]?.completed) {
      setAlreadyCompleted(true);
      setUserScore(userProgress[`day${challenge.day}`].score);
    }
  };

  const fetchDayLeaderboard = async () => {
    try {
      const progressCollection = collection(db, "adventProgress");
      const snapshot = await getDocs(progressCollection);

      // Get all users who completed this day
      const dayScores = [];
      snapshot.forEach((doc) => {
        const data = doc.data();
        const dayData = data[`day${challenge.day}`];
        if (dayData && dayData.completed) {
          dayScores.push({
            userId: doc.id,
            name: data.userName || "Unknown Player",
            score: dayData.score,
            completedAt: dayData.completedAt,
          });
        }
      });

      // Sort by score (highest first)
      dayScores.sort((a, b) => b.score - a.score);

      setDayLeaderboard(dayScores); // All players, not just top 10
      setLoading(false);
    } catch (error) {
      console.error("Error fetching day leaderboard:", error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-advent-primary-dark to-advent-secondary-dark flex items-center justify-center">
        <div className="text-white text-2xl">Laster...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-advent-primary-dark via-advent-primary to-advent-secondary-dark py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-5xl font-bold text-white mb-2">
            🎄 Luke {challenge.day} 🎄
          </h1>
          {alreadyCompleted && (
            <h2 className="text-3xl font-bold text-yellow-300 mb-2">
              {challenge.locationName}
            </h2>
          )}
          <p className="text-xl text-white">
            {alreadyCompleted
              ? "Du har fullført denne utfordringen!"
              : "Plasser en markør så nært som mulig på kartet!"}
          </p>
        </div>

        {/* Day Leaderboard */}
        <Leaderboard
          leaderboard={dayLeaderboard}
          currentUserId={user.uid}
          title="🏆 Dagens Resultatliste 🏆"
          emptyMessage="Ingen har fullført denne utfordringen ennå. Bli den første! 🎯"
          scoreLabel="score"
          showCount={5}
        />

        {/* Instructions */}
        <div className="bg-white bg-opacity-20 rounded-lg p-6 mb-8 mt-8 text-white">
          <h3 className="text-xl font-bold mb-3">📍 Hvordan spille:</h3>
          <ul className="space-y-2">
            <li>• Klikk på kartet for å plassere din markør</li>
            <li>• Jo nærmere du er, desto flere poeng får du</li>
            <li>• Maks 5000 poeng for perfekt plassering</li>
          </ul>
        </div>

        {/* Buttons */}
        <div className="flex gap-4">
          <button
            onClick={onBack}
            className="flex-1 px-8 py-4 bg-white bg-opacity-20 hover:bg-opacity-30 text-white text-xl font-bold rounded-lg transition-all"
          >
            ← Tilbake
          </button>
          {alreadyCompleted ? (
            <div className="flex-1 px-8 py-4 bg-gray-500 text-white text-xl font-bold rounded-lg text-center">
              ✓ Fullført ({userScore} pts)
            </div>
          ) : (
            <button
              onClick={onStart}
              className="flex-1 px-8 py-4 bg-advent-secondary hover:bg-advent-secondary-dark text-white text-xl font-bold rounded-lg shadow-xl transition-all duration-200 transform hover:scale-105"
            >
              Start Utfordring 🎯
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DayLeaderboard;
